import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { finalize, Observable } from "rxjs";
import { GlobalLoaderService } from "../services/global-loader.service";

@Injectable()
export class GlobalLoaderInterceptor implements HttpInterceptor {
	constructor(private globalLoaderService: GlobalLoaderService) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Exeption for loadCount request
		if (request.url.includes("unread")) {
			return next.handle(request);
		}

		this.globalLoaderService.showLoader();
		return next.handle(request).pipe(finalize(() => this.globalLoaderService.hideLoader()));
	}
}
